// Single source of truth for stock-driven quantity caps.
//
// `availableForSku(sku, warehouse?)` returns the maximum qty that can
// be added or saved for a given variant/warehouse combination.
//
//   * If `warehouse` is provided → return that warehouse's stock for
//     the SKU (used by the order sheet and order-review where lines
//     are committed to a warehouse).
//   * If `warehouse` is omitted → return the total stock across all
//     warehouses (used by the simple cart, which is SKU-only).
//
// Returns `null` if availability is unknown — callers should treat
// that as "no cap" rather than zero.

import { mockAvailability } from "./mockInventory";

export function availableForSku(sku, warehouse) {
  if (!sku) return null;
  const a = mockAvailability(sku, "b2b");
  if (!a) return null;
  if (warehouse) {
    const wh = (a.warehouses || []).find((w) => w.id === warehouse);
    return wh && typeof wh.available === "number" ? wh.available : null;
  }
  if (typeof a.available === "number") return a.available;
  const sum = (a.warehouses || []).reduce(
    (n, w) => n + (typeof w.available === "number" ? w.available : 0),
    0,
  );
  return sum || null;
}

// Validate a desired qty; returns { ok, max, capped }.
export function clampToStock(sku, desired, warehouse) {
  const avail = availableForSku(sku, warehouse);
  const want = Math.max(0, Number(desired) || 0);
  if (avail == null) return { ok: true, max: null, capped: want };
  if (want > avail) return { ok: false, max: avail, capped: avail };
  return { ok: true, max: avail, capped: want };
}
